import { Edge } from 'reactflow'

export default [] as Edge[]
